module.exports = __webpack_public_path__ + "img/school-bus-side-view.c25ac1ff.png";